import { useQuery } from "@apollo/client/react/hooks/useQuery";
import { meGQL, Query } from "@onmo/graphql/graphql";
import { useStyles } from "./Profile.style";
import ProfileStats from "../../components/common/ProfileStats/ProfileStats";
import ProfileHeader from "../../components/common/ProfileHeader/ProfileHeader";
import ProfileActivity from "../../components/common/ProfileActivity/ProfileActivity";

const Profile: React.FC = () => {
  const classes = useStyles();
  const { data: dataMe } = useQuery<{ me: Query["me"] }>(meGQL);

  return (
    <div className={classes.container}>
      <ProfileHeader
        avatar={dataMe?.me.avatar}
        username={dataMe?.me.username}
      />
      <ProfileStats id={dataMe?.me.id} />
      <ProfileActivity me={dataMe?.me} />
    </div>
  );
};
export default Profile;
